// import Main from './Main'
const Importador = () => import('./components/Importador')

export default [
  {path: 'importador', component: Importador, name: 'importador.main'}
]
